export default __webpack_public_path__ + "static/media/Warmup Track Athletics1.8ebf3f4b.jpg";